import DOMPurify from 'dompurify';
import { TIPTAP_EDITOR_SCHEMA_VERSION } from './types.js';
import { DOMSerializer } from '@tiptap/pm/model';

const tiptapSanitizeContent = (content) => {
  return DOMPurify.sanitize(content, {
    ALLOWED_TAGS: [
      "em",
      "strong",
      "a",
      "code",
      "s",
      "i",
      "b",
      "u",
      "mark",
      "br",
      "a",
      "p",
      "ol",
      "ul",
      "li",
      "blockquote",
      "pre",
      "code",
      "img",
      "table",
      "tr",
      "td",
      "th",
      "tbody",
      "thead",
      "tfoot",
      "caption",
      "div",
      "span",
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
      "input"
    ],
    ALLOWED_ATTR: [
      "href",
      "target",
      "rel",
      "class",
      "src",
      "alt",
      "width",
      "data-uuid",
      "data-created-at",
      "data-checked",
      "data-type",
      "data-role",
      "type",
      "checked"
    ]
  });
};
const previewUnwantedAttributes = [
  "contenteditable",
  "data-uuid",
  "data-created-at"
];
const generateContentPreview = (content, _maxCharacters = 200) => {
  const maxCharacters = _maxCharacters === false ? 0 : _maxCharacters - 1;
  const parser = new DOMParser();
  const doc = parser.parseFromString(content, "text/html");
  const body = doc.body;
  let newHtml = "";
  let charCount = 0;
  const appendText = (text) => {
    const sliceAmount = maxCharacters === 0 ? text.length : Math.min(maxCharacters - charCount, text.length);
    if (sliceAmount <= 0 && maxCharacters > 0) {
      return;
    }
    newHtml += text.slice(0, sliceAmount) + (sliceAmount < text.length ? "…" : "");
    charCount += sliceAmount;
  };
  const traverse = (node) => {
    if (charCount >= maxCharacters && maxCharacters > 0) {
      return;
    }
    if (node.nodeType === Node.TEXT_NODE) {
      appendText(node.textContent || "");
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      const element = node;
      newHtml += `<${element.tagName.toLowerCase()}`;
      for (const attr of element.attributes) {
        if (previewUnwantedAttributes.includes(attr.name)) {
          continue;
        }
        newHtml += ` ${attr.name}="${attr.value}"`;
      }
      newHtml += ">";
      for (const child of element.childNodes) {
        traverse(child);
      }
      newHtml += `</${element.tagName.toLowerCase()}>`;
    }
  };
  for (const child of body.childNodes) {
    traverse(child);
  }
  return tiptapSanitizeContent(newHtml);
};
const convertHTMLToMarkdown = (html) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");
  const body = doc.body;
  return body.textContent || "";
};
const generateHTMLFromFragment = (fragment, schema) => {
  const serializer = DOMSerializer.fromSchema(schema);
  const container = document.createElement("div");
  serializer.serializeFragment(fragment, void 0, container);
  return tiptapSanitizeContent(container.innerHTML);
};
const getTiptapDataValue = (editor, oldValue) => {
  const slice = editor.state.doc.slice(0, Math.min(editor.state.doc.content.size, 2e3), true);
  const content = generateHTMLFromFragment(slice.content, editor.state.doc.type.schema);
  const markdown = convertHTMLToMarkdown(content);
  return {
    version: TIPTAP_EDITOR_SCHEMA_VERSION,
    content,
    lastUpdated: Date.now(),
    time: Date.now(),
    blocks: [
      {
        type: "paragraph",
        data: {
          text: markdown
        }
      }
    ],
    // Keep old data for backwards compatibility
    data: oldValue?.data
  };
};

export { generateContentPreview, generateHTMLFromFragment, getTiptapDataValue, tiptapSanitizeContent };
//# sourceMappingURL=content.js.map
